export default __webpack_public_path__ + "static/media/background.861d241a.mp3";